import React, { useEffect, useState } from "react";
import { MenuItem, Select, CircularProgress } from "@material-ui/core";
import axios from "axios";
import { Autocomplete, TextField } from "@material-ui/core";

function GetChargeAccount({
  GLAccount,
  changeHandler,
  index,
  disabled,
  bordered,
  item,
  setAlertMessage,
  setErrAlertMessage,
}) {
  const [gl_account, setGl_account] = useState([]);
  const [loading, setLoading] = useState(false);

  const getg_laccount = async (account) => {
    setLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${
        account ? account : -1
      }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setGl_account(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);

        // setErrorMessage("Invalid username or password");
      });
  };
  useEffect(() => {
    if (GLAccount) {
      getg_laccount(GLAccount);
    } else {
      getg_laccount();
    }
  }, [GLAccount]);
  return (
    <div>
      <Autocomplete
        id="selectedTaxCode"
        freeSolo
        options={gl_account}
        size="small"
        disabled={disabled}
        name="glAccount"
        value={{
          GLAccount: GLAccount || "",
          ShortText:
            gl_account?.find((x) => x.GLAccount === GLAccount)?.ShortText || "",
        }}
        // getOptionLabel={(option) =>
        //   (option !== "" &&
        //     `${option?.GLAccount || ""} ${option?.ShortText ? "-" : ""}${option?.ShortText || ""}`) ||
        //   ""
        // }
        getOptionLabel={(option) =>
          option
            ? `${option.GLAccount}${option.ShortText ? "-" : ""}${
                option.ShortText
              }`
            : ""
        }
        // key={(option) => option?.category}
        loading={loading}
        variant="standard"
        onChange={(event, newValue) => {
          changeHandler(
            { target: { name: "glAccount", value: newValue?.GLAccount } },
            index,
            item?.rowId
          );

          if (!newValue?.IsActive && newValue != null) {
            setAlertMessage(true);
            setErrAlertMessage("This Gl Account has been Blocked");
          }
          // autoCompleteChangeHandler("category", newValue, index);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name=""
            onChange={(event) => {
              changeHandler(
                { target: { name: "glAccount", value: event.target.value } },
                index
              );
              getg_laccount(event.target.value);
            }}
            variant={`${bordered ? "outlined" : "standard"}`}
            required
            InputLabelProps={{ shrink: false, required: false }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
              // disableUnderline: true
            }}
            // placeholder="Select GLaccount"
          />
        )}
      />
      {/* <Select
        fullWidth
        size="small"
        name="glAccount"
        // labelId="demo-simple-select-label"
        // value={GLAccount}
        variant="standard"
        id="demo-simple-select"
        disabled={disabled}
        onChange={(event) => changeHandler(event, index)}
        inputProps={{ "aria-label": "Without label" }}
      >
        {!loading ? (
          gl_account.length > 0 ? (
            gl_account.map((item) => (
              <MenuItem
                value={item?.GLAccount}
              >{`${item?.GLAccount}-${item?.ShortText}`}</MenuItem>
            ))
          ) : (
            <MenuItem disabled>Not Found</MenuItem>
          )
        ) : (
          <MenuItem>
            <CircularProgress size={24} />
          </MenuItem>
        )}
      </Select> */}
    </div>
  );
}

export default React.memo(GetChargeAccount);
